import React, { useState } from "react";
import ProductTable from "../../../../../../../Components/BoltTable/BoltTable";
import { fetchAllPackages } from "../../../../../../../services/ShipperServices/Packages/packages.services";
import { NameCell, PackagePhotoCell, PackageSizeCell } from "../Products/LibraryCells";
import { BsPlus } from "react-icons/bs";

export default function PackageListView(props) {
  const { handlescrollpackage, refresh, headerButtons } = props;
  const [packages, setPackages] = useState([]);

  const columns = [
    // {
    //   id: 0,
    //   label: "#",
    //   render: (row) => <>{row?.id ?? "-"}</>,
    //   width: "200px",
    // },
    // Three columns in the Products list's style (the redesign): the photo as
    // the row's button, Package (the old Name), Size & Weight (the old
    // Dimentions and Weight, in the package's own unit). LibraryCells.jsx.
    {
      id: 1,
      label: " ",
      render: (row) => <PackagePhotoCell row={row} />,
      fixed: "left",
      width: "60px",
    },
    {
      id: 2,
      label: "Package",
      render: (row) => <NameCell row={row} />,
      width: "560px",
    },
    {
      id: 3,
      label: "Size & Weight",
      render: (row) => <PackageSizeCell row={row} />,
      width: "260px",
    },
    // {
    //   id: 8,
    //   label: "Actions",
    //   render: (row) => (
    //     <>
    //       {" "}
    //       <div className="table_action__wrap">
    //         <div
    //           className="table_action__btn"
    //           onClick={() => handlescrollpackage(row)}
    //         >
    //           <BsPlus size={10} />
    //           Add
    //         </div>
    //       </div>
    //     </>
    //   ),
    //   width: "200px",
    // },
  ];

  const getAllPackages = async (page, perPage, filter) => {
    const response = await fetchAllPackages(page, perPage, filter);
    if (!response.error) {
      setPackages(response?.data?.result);
    } else {
    }
  };

  return (
    <>
      <div className="custom__table_size1 actionbtn__needtobe_fixwidth">
        <ProductTable
          tableId="packageListViewTableforShipper_v2"
          message={"No Packages Available To Display!"}
          searchPlaceHolder={"Search Packages"}
          getAllData={getAllPackages}
          data={packages}
          columns={columns}
          refresh={refresh}
          handleRowClick={handlescrollpackage}
          isRowClick="Click To Add"
          disableAutoResizing={true}
          headerButtons={headerButtons}
        />
      </div>
    </>
  );
}
